<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/press-release",
		    "name": "Press Release DSCI Finsec Award"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="breadcrumbsul">
                    <li><a href="#">Home</a></li>
                    <li>></li>
                    <li>Press Release DSCI Finsec Award</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="section-agency-benefit bg-gray">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center section-title mt-30">
                <h4>Leading Mobile Threat Defence &amp; cybersecurity company, Protectt.ai wins
                    DSCI Innovation Box 2023 Award</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6 col-sm-12 col-xs-12 text-center mt-2">
                <img class="w-100" src="../../../assets/images/pressrelease/employee.webp" alt="Press Release Image">
            </div>
            <div class="col-md-3"></div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="agency-benefits">
                    <div class="content mb-50">
                        <p>
                            <strong>Mumbai, 29<sup>th</sup> May 2023:</strong>&nbsp;<span
                                style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span>, a
                            leading Mobile Threat Defence &amp; cybersecurity company, has
                            been announced as the winner of the Innovation Box 2023 at the 10th edition of Data Security
                            Council of India (DSCI). The recognition further highlights the company’s commitment to
                            offering
                            innovative Mobile App Security Platform that provide maximum protection to businesses by
                            controlling cyber threats and Frauds to Mobile Apps.
                        </p>
                        <p>
                            Commenting on this win,<strong> Manish Mimani, CEO and Founder, <span
                                    style="color: #163e6f;">Protectt.</span><span
                                    style="color: #da2b27;">ai</span></strong> said, <em>“We are delighted and
                                humbled to be recognized by DSCI as the Innovation Box 2023 winner. This recognition is
                                a
                                testament of our team’s hard work and dedication to developing the best security
                                solutions focussed
                                on emerging Mobile Threats &amp; Frauds. This recognition has encouraged us to continue
                                innovating
                                and developing solutions that provides the highest level of protection to businesses,
                                mobile banking
                                apps, and individuals alike.”</em>
                        </p>
                        <p>
                            <strong>Vinayak Godse, CEO Data Security Council of India said,</strong> “For over a decade,
                            the Innovation Box has
                            served as a premier platform for innovators to exhibit their innovative cybersecurity
                            products. The
                            initiative has gained widespread recognition, allowing industry leaders to identify and
                            honour the
                            most innovative product of the year. Going forward, the Innovation Box seeks to expand its
                            influence by venturing into additional sectors, fostering a culture of innovation throughout
                            various
                            industries.”
                        </p>
                        <p>
                            To further bring advancements in RunTime Application Self Protection driven Mobile Threat
                            Defence, Protectt.ai is now planning to raise $10-12 m in Series A funding. As its next
                            level of
                            growth, the company further intends to provide Mobile App &amp; Device security, covering 2
                            billion
                            Mobile App sessions every month, spanning over 200 million smartphone users in India.
                        </p>
                        <p>
                            The event also highlighted the pivotal role of cybersecurity in today’s world and immense
                            opportunities that lie ahead while acknowledging the daunting challenges that need to be
                            addressed
                            collectively. With a special emphasis on the significance of digitizing payments, the event
                            further
                            emphasised on the future of finance, its scalability and innovation, rapid adoption of
                            emerging
                            technologies, growing digital footprint and how finance has intertwined with every digital
                            aspect.
                            And hence why concerted efforts and continuous learning are required in managing the complex
                            challenges of security, privacy, and fraud.
                        </p>
                        <p><strong>About Protectt.ai:</strong></p>
                        <p>
                            <span style="color: #163e6f;">Protectt.</span><span style="color: #da2b27;">ai</span> is a
                            Mobile Threat Defense (MTD) cyber-security organization offering next
                            generation
                            Mobile App, Device &amp; Transaction security solution driven by Deep Tech. AppProtectt is
                            Industry
                            First Innovation with unique Runtime Application Self Protection for Mobile App Security.
                            The
                            company has set-up offices in Gurgaon, Mumbai and Chennai including an innovation center
                            where
                            a team of dedicated product &amp; cyber security experts continuously strives to solve
                            complex mobile
                            cyber security challenges.
                        </p>
                        <p>
                            The company has embraced a vision to provide Mobile App &amp; Device security covering two
                            billion
                            Mobile App Sessions every month spanning over 200 million smartphone users in India over the
                            next
                            two years.
                        </p>
                        <p>For more information, please visit <span style="color: #163e6f;"><a href="https://protectt.ai/">https://protectt.ai/</a></span>
                        </p>
                        <p><strong>About DSCI (Data Security Council of India):</strong></p>
                        <p>Data Security Council of India (DSCI) is a not-for-profit, industry body on data protection
                            in India,
                            setup by NASSCOM®, committed to making the cyberspace safe, secure, and trusted by
                            establishing
                            best practices, standards and initiatives in cyber security and privacy.</p>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/cyber-lab-services/assessment_services.webp"
              alt="Implement Cyber Security Consultants for your Business" />
          </div>
        </div>
      </div> -->
        </div>
    </div>
</div>
<!-- End Info Area -->